export default "__VITE_ASSET__ZF543FXY__"